<template>
    <Breadcrumbs main="Form Widgets" title="Date Picker" />
    <div class="container-fluid">
        <div class="row">
            <defaultCalander />
            <bootstrapCalendar />
            <datePicker />
            <timePicker />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const defaultCalander = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/datepicker/defaultCalander.vue"))
const bootstrapCalendar = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/datepicker/bootstrapCalendar.vue"))
const datePicker = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/datepicker/datePicker.vue"))
const timePicker = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/datepicker/timePicker.vue"))
</script>